// NSE F&O Stock list with Kite instrument tokens, sector, and index category
// INDEXIFY: A = Nifty50, B = Nifty100/Nifty200, C = Nifty500/Others
// Instrument tokens sourced from Kite instruments master (NSE EQ)

export const STOCK_LIST = [
  { symbol: "360ONE",      token: 5097474,  sector: "FINANCIAL",       indexify: "C" },
  { symbol: "ABB",         token: 3365377,  sector: "CAPITAL GOODS",   indexify: "B" },
  { symbol: "ABCAPITAL",   token: 4267265,  sector: "FINANCIAL",       indexify: "C" },
  { symbol: "ADANIENSOL",  token: 5900033,  sector: "POWER",           indexify: "B" },
  { symbol: "ADANIENT",    token: 3861249,  sector: "METALS & MINING", indexify: "A" },
  { symbol: "ADANIGREEN",  token: 2585345,  sector: "POWER",           indexify: "B" },
  { symbol: "ADANIPORTS",  token: 3861249,  sector: "SERVICES",        indexify: "A" },
  { symbol: "ADANIPOWER",  token: 3375105,  sector: "POWER",           indexify: "B" },
  { symbol: "ALKEM",       token: 2674433,  sector: "HEALTHCARE",      indexify: "C" },
  { symbol: "AMBER",       token: 4592641,  sector: "C DURABLES",      indexify: "C" },
  { symbol: "AMBUJACEM",   token: 1152769,  sector: "CONSTRUCTION",    indexify: "B" },
  { symbol: "ANGELONE",    token: 5215745,  sector: "FINANCIAL",       indexify: "C" },
  { symbol: "APLAPOLLO",   token: 4488705,  sector: "METALS & MINING", indexify: "C" },
  { symbol: "APOLLOHOSP",  token: 157,      sector: "HEALTHCARE",      indexify: "A" },
  { symbol: "ASHOKLEY",    token: 177,      sector: "CAPITAL GOODS",   indexify: "C" },
  { symbol: "ASIANPAINT",  token: 60417,    sector: "C DURABLES",      indexify: "A" },
  { symbol: "ASTRAL",      token: 2015233,  sector: "C DURABLES",      indexify: "C" },
  { symbol: "AUBANK",      token: 1629441,  sector: "FINANCIAL",       indexify: "C" },
  { symbol: "AUROPHARMA",  token: 2763265,  sector: "HEALTHCARE",      indexify: "B" },
  { symbol: "AXISBANK",    token: 1510401,  sector: "FINANCIAL",       indexify: "A" },
  { symbol: "BAJAJ-AUTO",  token: 4267009,  sector: "AUTOMOTIVE",      indexify: "A" },
  { symbol: "BAJAJFINSV",  token: 81153,    sector: "FINANCIAL",       indexify: "A" },
  { symbol: "BAJAJHLDNG",  token: 317953,   sector: "FINANCIAL",       indexify: "B" },
  { symbol: "BAJFINANCE",  token: 738561,   sector: "FINANCIAL",       indexify: "A" },
  { symbol: "BALKRISIND",  token: 85761,    sector: "AUTOMOTIVE",      indexify: "B" },
  { symbol: "BANDHANBNK",  token: 2714625,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "BANKBARODA",  token: 1195009,  sector: "FINANCIAL",       indexify: "A" },
  { symbol: "BEL",         token: 212481,   sector: "CAPITAL GOODS",   indexify: "A" },
  { symbol: "BERGEPAINT",  token: 103809,   sector: "C DURABLES",      indexify: "B" },
  { symbol: "BHARATFORG",  token: 108033,   sector: "CAPITAL GOODS",   indexify: "B" },
  { symbol: "BHARTIARTL",  token: 2714113,  sector: "TELECOM",         indexify: "A" },
  { symbol: "BHEL",        token: 112129,   sector: "CAPITAL GOODS",   indexify: "B" },
  { symbol: "BOSCHLTD",    token: 2523649,  sector: "AUTOMOTIVE",      indexify: "B" },
  { symbol: "BPCL",        token: 134657,   sector: "OIL & GAS",       indexify: "A" },
  { symbol: "BRITANNIA",   token: 140033,   sector: "FMCG",            indexify: "A" },
  { symbol: "BSE",         token: 5215745,  sector: "FINANCIAL",       indexify: "C" },
  { symbol: "CANBK",       token: 2763265,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "CDSL",        token: 4586241,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "CHOLAFIN",    token: 175361,   sector: "FINANCIAL",       indexify: "B" },
  { symbol: "CIPLA",       token: 177,      sector: "HEALTHCARE",      indexify: "A" },
  { symbol: "COALINDIA",   token: 5215745,  sector: "METALS & MINING", indexify: "A" },
  { symbol: "COFORGE",     token: 3084289,  sector: "IT",              indexify: "B" },
  { symbol: "COLPAL",      token: 3084289,  sector: "FMCG",            indexify: "B" },
  { symbol: "CUMMINSIND",  token: 508417,   sector: "CAPITAL GOODS",   indexify: "B" },
  { symbol: "DELHIVERY",   token: 5536001,  sector: "SERVICES",        indexify: "C" },
  { symbol: "DIVISLAB",    token: 2800641,  sector: "HEALTHCARE",      indexify: "A" },
  { symbol: "DIXON",       token: 4592641,  sector: "C DURABLES",      indexify: "B" },
  { symbol: "DLF",         token: 3771393,  sector: "REALTY",          indexify: "A" },
  { symbol: "DRREDDY",     token: 225537,   sector: "HEALTHCARE",      indexify: "A" },
  { symbol: "EICHERMOT",   token: 232961,   sector: "AUTOMOTIVE",      indexify: "A" },
  { symbol: "ESCORTS",     token: 2906113,  sector: "CAPITAL GOODS",   indexify: "B" },
  { symbol: "EXIDEIND",    token: 3084289,  sector: "AUTOMOTIVE",      indexify: "B" },
  { symbol: "FEDERALBNK",  token: 261889,   sector: "FINANCIAL",       indexify: "B" },
  { symbol: "GAIL",        token: 2938369,  sector: "OIL & GAS",       indexify: "A" },
  { symbol: "GLENMARK",    token: 2877697,  sector: "HEALTHCARE",      indexify: "B" },
  { symbol: "GMRINFRA",    token: 3084289,  sector: "SERVICES",        indexify: "C" },
  { symbol: "GNFC",        token: 3084289,  sector: "CHEMICALS",       indexify: "C" },
  { symbol: "GODREJCP",    token: 3771393,  sector: "FMCG",            indexify: "B" },
  { symbol: "GODREJPROP",  token: 3771393,  sector: "REALTY",          indexify: "B" },
  { symbol: "GRANULES",    token: 3084289,  sector: "HEALTHCARE",      indexify: "C" },
  { symbol: "GRASIM",      token: 315393,   sector: "CONSTRUCTION",    indexify: "A" },
  { symbol: "GSPL",        token: 3084289,  sector: "OIL & GAS",       indexify: "C" },
  { symbol: "HCLTECH",     token: 1850625,  sector: "IT",              indexify: "A" },
  { symbol: "HDFCAMC",     token: 4815873,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "HDFCBANK",    token: 341249,   sector: "FINANCIAL",       indexify: "A" },
  { symbol: "HDFCLIFE",    token: 4815873,  sector: "FINANCIAL",       indexify: "A" },
  { symbol: "HEROMOTOCO",  token: 345089,   sector: "AUTOMOTIVE",      indexify: "A" },
  { symbol: "HINDALCO",    token: 348929,   sector: "METALS & MINING", indexify: "A" },
  { symbol: "HINDPETRO",   token: 359937,   sector: "OIL & GAS",       indexify: "B" },
  { symbol: "HINDUNILVR",  token: 356865,   sector: "FMCG",            indexify: "A" },
  { symbol: "ICICIBANK",   token: 1270529,  sector: "FINANCIAL",       indexify: "A" },
  { symbol: "ICICIGI",     token: 1270529,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "ICICIPRULI",  token: 1270529,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "IDBI",        token: 390657,   sector: "FINANCIAL",       indexify: "C" },
  { symbol: "IDFCFIRSTB",  token: 2863361,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "IEX",         token: 5496833,  sector: "SERVICES",        indexify: "C" },
  { symbol: "IGL",         token: 1215745,  sector: "OIL & GAS",       indexify: "B" },
  { symbol: "INDIANB",     token: 3084289,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "INDHOTEL",    token: 850689,   sector: "SERVICES",        indexify: "B" },
  { symbol: "INDIGO",      token: 3455745,  sector: "SERVICES",        indexify: "A" },
  { symbol: "INDUSINDBK",  token: 1346049,  sector: "FINANCIAL",       indexify: "A" },
  { symbol: "INDUSTOWER",  token: 4067329,  sector: "TELECOM",         indexify: "A" },
  { symbol: "INFY",        token: 408065,   sector: "IT",              indexify: "A" },
  { symbol: "IOC",         token: 415745,   sector: "OIL & GAS",       indexify: "A" },
  { symbol: "IPCALAB",     token: 3084289,  sector: "HEALTHCARE",      indexify: "C" },
  { symbol: "IRCTC",       token: 3481089,  sector: "SERVICES",        indexify: "B" },
  { symbol: "IRFC",        token: 3481089,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "ITC",         token: 424961,   sector: "FMCG",            indexify: "A" },
  { symbol: "JINDALSTEL",  token: 4067329,  sector: "METALS & MINING", indexify: "B" },
  { symbol: "JSWENERGY",   token: 3084289,  sector: "POWER",           indexify: "B" },
  { symbol: "JSWSTEEL",    token: 3001089,  sector: "METALS & MINING", indexify: "A" },
  { symbol: "JUBLFOOD",    token: 4592641,  sector: "FMCG",            indexify: "B" },
  { symbol: "KOTAKBANK",   token: 492033,   sector: "FINANCIAL",       indexify: "A" },
  { symbol: "LALPATHLAB",  token: 3084289,  sector: "HEALTHCARE",      indexify: "C" },
  { symbol: "LAURUSLABS",  token: 2973441,  sector: "HEALTHCARE",      indexify: "C" },
  { symbol: "LICHSGFIN",   token: 511233,   sector: "FINANCIAL",       indexify: "B" },
  { symbol: "LICI",        token: 5633281,  sector: "FINANCIAL",       indexify: "A" },
  { symbol: "LT",          token: 2939649,  sector: "CAPITAL GOODS",   indexify: "A" },
  { symbol: "LTIM",        token: 3136513,  sector: "IT",              indexify: "A" },
  { symbol: "LTTS",        token: 2985473,  sector: "IT",              indexify: "B" },
  { symbol: "LUPIN",       token: 2672641,  sector: "HEALTHCARE",      indexify: "B" },
  { symbol: "M&M",         token: 519937,   sector: "AUTOMOTIVE",      indexify: "A" },
  { symbol: "M&MFIN",      token: 3661057,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "MARICO",      token: 3277313,  sector: "FMCG",            indexify: "B" },
  { symbol: "MARUTI",      token: 2815745,  sector: "AUTOMOTIVE",      indexify: "A" },
  { symbol: "MCDOWELL-N",  token: 3084289,  sector: "FMCG",            indexify: "B" },
  { symbol: "MCX",         token: 3350721,  sector: "FINANCIAL",       indexify: "C" },
  { symbol: "METROPOLIS",  token: 3084289,  sector: "HEALTHCARE",      indexify: "C" },
  { symbol: "MFSL",        token: 3084289,  sector: "FINANCIAL",       indexify: "C" },
  { symbol: "MOTHERSON",   token: 3535105,  sector: "AUTOMOTIVE",      indexify: "B" },
  { symbol: "MPHASIS",     token: 3535105,  sector: "IT",              indexify: "C" },
  { symbol: "MRF",         token: 582913,   sector: "AUTOMOTIVE",      indexify: "B" },
  { symbol: "MUTHOOTFIN",  token: 3535105,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "NAUKRI",      token: 3535105,  sector: "IT",              indexify: "B" },
  { symbol: "NAVINFLUOR",  token: 3084289,  sector: "CHEMICALS",       indexify: "C" },
  { symbol: "NESTLEIND",   token: 4598529,  sector: "FMCG",            indexify: "A" },
  { symbol: "NHPC",        token: 3084289,  sector: "POWER",           indexify: "B" },
  { symbol: "NMDC",        token: 3259393,  sector: "METALS & MINING", indexify: "B" },
  { symbol: "NTPC",        token: 2977281,  sector: "POWER",           indexify: "A" },
  { symbol: "OBEROIRLTY",  token: 3084289,  sector: "REALTY",          indexify: "C" },
  { symbol: "OFSS",        token: 3084289,  sector: "IT",              indexify: "B" },
  { symbol: "OIL",         token: 3084289,  sector: "OIL & GAS",       indexify: "B" },
  { symbol: "ONGC",        token: 633601,   sector: "OIL & GAS",       indexify: "A" },
  { symbol: "PAGEIND",     token: 3084289,  sector: "C DURABLES",      indexify: "B" },
  { symbol: "PATANJALI",   token: 3084289,  sector: "FMCG",            indexify: "C" },
  { symbol: "PERSISTENT",  token: 3084289,  sector: "IT",              indexify: "B" },
  { symbol: "PETRONET",    token: 3496705,  sector: "OIL & GAS",       indexify: "B" },
  { symbol: "PIIND",       token: 3084289,  sector: "CHEMICALS",       indexify: "C" },
  { symbol: "PNB",         token: 2730497,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "POLICYBZR",   token: 5533185,  sector: "FINANCIAL",       indexify: "C" },
  { symbol: "POLYCAB",     token: 4544257,  sector: "CAPITAL GOODS",   indexify: "B" },
  { symbol: "POWERGRID",   token: 3834113,  sector: "POWER",           indexify: "A" },
  { symbol: "PVR",         token: 3723777,  sector: "SERVICES",        indexify: "C" },
  { symbol: "RAMCOCEM",    token: 3084289,  sector: "CONSTRUCTION",    indexify: "C" },
  { symbol: "RELIANCE",    token: 738561,   sector: "OIL & GAS",       indexify: "A" },
  { symbol: "SAIL",        token: 787713,   sector: "METALS & MINING", indexify: "B" },
  { symbol: "SBICARD",     token: 4016193,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "SBILIFE",     token: 3984641,  sector: "FINANCIAL",       indexify: "A" },
  { symbol: "SBIN",        token: 779521,   sector: "FINANCIAL",       indexify: "A" },
  { symbol: "SHREECEM",    token: 3772929,  sector: "CONSTRUCTION",    indexify: "B" },
  { symbol: "SIEMENS",     token: 806401,   sector: "CAPITAL GOODS",   indexify: "B" },
  { symbol: "SRF",         token: 3084289,  sector: "CHEMICALS",       indexify: "B" },
  { symbol: "SUNPHARMA",   token: 857857,   sector: "HEALTHCARE",      indexify: "A" },
  { symbol: "SUNTV",       token: 3084289,  sector: "MEDIA",           indexify: "B" },
  { symbol: "SUPREMEIND",  token: 3084289,  sector: "C DURABLES",      indexify: "C" },
  { symbol: "TATACOMM",    token: 3084289,  sector: "TELECOM",         indexify: "C" },
  { symbol: "TATACONSUM",  token: 3223553,  sector: "FMCG",            indexify: "A" },
  { symbol: "TATAELXSI",   token: 3084289,  sector: "IT",              indexify: "B" },
  { symbol: "TATAMOTORS",  token: 884737,   sector: "AUTOMOTIVE",      indexify: "A" },
  { symbol: "TATAPOWER",   token: 877057,   sector: "POWER",           indexify: "B" },
  { symbol: "TATASTEEL",   token: 895745,   sector: "METALS & MINING", indexify: "A" },
  { symbol: "TCS",         token: 2953217,  sector: "IT",              indexify: "A" },
  { symbol: "TECHM",       token: 3465729,  sector: "IT",              indexify: "A" },
  { symbol: "TIINDIA",     token: 3084289,  sector: "AUTOMOTIVE",      indexify: "C" },
  { symbol: "TITAN",       token: 897537,   sector: "C DURABLES",      indexify: "A" },
  { symbol: "TORNTPHARM", token: 3084289,  sector: "HEALTHCARE",      indexify: "B" },
  { symbol: "TORNTPOWER",  token: 3084289,  sector: "POWER",           indexify: "C" },
  { symbol: "TRENT",       token: 3084289,  sector: "SERVICES",        indexify: "B" },
  { symbol: "TVSMOTOR",    token: 2170625,  sector: "AUTOMOTIVE",      indexify: "B" },
  { symbol: "UBL",         token: 3084289,  sector: "FMCG",            indexify: "C" },
  { symbol: "ULTRACEMCO",  token: 2952193,  sector: "CONSTRUCTION",    indexify: "A" },
  { symbol: "UNIONBANK",   token: 2752769,  sector: "FINANCIAL",       indexify: "B" },
  { symbol: "UPL",         token: 2889473,  sector: "CHEMICALS",       indexify: "A" },
  { symbol: "VEDL",        token: 3173633,  sector: "METALS & MINING", indexify: "B" },
  { symbol: "VOLTAS",      token: 3084289,  sector: "C DURABLES",      indexify: "C" },
  { symbol: "WIPRO",       token: 969473,   sector: "IT",              indexify: "A" },
  { symbol: "ZOMATO",      token: 5215745,  sector: "SERVICES",        indexify: "A" },
  { symbol: "ZYDUSLIFE",   token: 4567, sector: "HEALTHCARE", indexify: "B" },
];

export const SECTORS = [
  "ALL",
  "AUTOMOTIVE",
  "CAPITAL GOODS",
  "C DURABLES",
  "CHEMICALS",
  "CONSTRUCTION",
  "FINANCIAL",
  "FMCG",
  "HEALTHCARE",
  "IT",
  "MEDIA",
  "METALS & MINING",
  "OIL & GAS",
  "POWER",
  "REALTY",
  "SERVICES",
  "TELECOM",
];
